webpackJsonp([176538155531088],{

/***/ 746:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":2,"edges":[{"node":{"fields":{"slug":"/limited-edition-halloween-2018/"},"excerpt":"Introducing Universal Studios Little Monsters Licensed Charms Bring your Living Locket® back to life with our officially-licensed, Limited…","timeToRead":1,"frontmatter":{"title":"Limited Edition Halloween Collection is back for 2018","category":"limited edition"}}},{"node":{"fields":{"slug":"/limited-edition-triangle-locket/"},"excerpt":"Meet our most versatile and unique Living Locket yet: the Triangle Living Locket! Change up your look by adjusting the Chain with its on…","timeToRead":1,"frontmatter":{"title":"Introducing the Limited Edition Triangle Living Locket with Bolo & Lariat","category":"limited edition"}}}]},"site":{"siteMetadata":{"facebook":{"appId":"885294908345276"}}}},"pathContext":{"category":"limited edition"}}

/***/ })

});


// WEBPACK FOOTER //
// path---category-limited-edition-3c5928f03f3dc988e7da.js